export const showLeftSideBar = true